import { IFullPlanDetail, IFullPlanDetailPPO } from "../../../interfaces/api";
import {
  getDoubleDataPPO,
  getDoubleDeepHMO,
  getDoubleDeepPPO,
  getSingleDeepHMO,
} from "../../../functions/planDetails";
import SingleInfoBenefitTripled from "./SingleInfoBenefitTripled.component";
import PPODoubleInfoBenefitTripled from "./PPODoubleInfoBenefitTripled.component";
import comArray from "../../../shared/CompareData";
import comFullArrayEquality from "../../../shared/EqualityArray.component";
import PPODoubleDeepInfoBenefitTripled from "./PPODoubleDeepBenefitTripled.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

interface IProps {
  compData: IFullPlanDetail[] | IFullPlanDetailPPO[];
  highlightDifferences: boolean;
  uniqueName: string;
}

const ComparisonTableAdditionalBenefits = (props: IProps) => {
  const { selectedYear } = useZipRootLoaderData();
  const plansNumber = props.compData.length;
  const equality = comFullArrayEquality(props.compData);

  const benefitsEqualityData = equality.find(
    (item) => item.name === props.uniqueName
  );

  const isConciergeEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "24/7 Concierge Service"
  )?.equal;
  const isOTCEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "Over-the-Counter (OTC) Allowance"
  )?.equal;
  const isFlexEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "FLEX Allowance"
  )?.equal;
  const isTransEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "Transportation"
  )?.equal;
  const isCaregiverEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "Caregiver Support"
  )?.equal;
  const isSSBCIEqual = benefitsEqualityData?.childrens.find(
    (item) => item.name === "Grocery SSBCI Eligible"
  )?.equal;

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
      }}
    >
      {comArray.map((segment) =>
        segment.name === props.uniqueName
          ? segment.childrens.map((part, index) => (
              <div
                className="grid-x small-12"
                key={index}
                style={{ fontSize: "18px" }}
              >
                <div
                  className={
                    plansNumber === 3 ? "cell small-3" : "cell small-4"
                  }
                  style={{
                    height: "100%",
                    padding: "32px 20px",
                    borderBottom: "1px solid #D3E1F0",
                    textAlign: "start",
                    fontWeight: 600,
                  }}
                >
                  {part.name}
                </div>
                {props.compData.map((plan, index) => (
                  <div
                    className={
                      plansNumber === 3 ? "cell small-3" : "cell small-4"
                    }
                    key={index}
                  >
                    {part.name === "24/7 Concierge Service" && (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          padding: "32px 20px",
                          borderBottom: "1px solid #D3E1F0",
                          textAlign: "start",
                          backgroundColor:
                            props.highlightDifferences && !isConciergeEqual
                              ? "#F4F0ED"
                              : "transparent",
                        }}
                      >
                        <div style={{ paddingLeft: 12 }}>$0</div>
                      </div>
                    )}
                    {part.name === "Over-the-Counter (OTC) Allowance" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isOTCEqual}
                          benefit={getSingleDeepHMO(
                            plan as IFullPlanDetail,
                            "Over-The-Counter (OTC)"
                          )}
                        />
                      ) : (
                        <PPODoubleDeepInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isOTCEqual}
                          benefit={getDoubleDeepPPO(
                            plan as IFullPlanDetailPPO,
                            "Over-The-Counter (OTC)",
                            selectedYear === 2024
                              ? "Over-the-Counter (OTC)"
                              : "Over-The-Counter (OTC)"
                          )}
                        />
                      )
                    ) : null}
                    {part.name === "FLEX Allowance" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isFlexEqual}
                          benefit={getDoubleDeepHMO(
                            plan as IFullPlanDetail,
                            "SSBCI",
                            "Flex Allowance"
                          )}
                        />
                      ) : (
                        <PPODoubleDeepInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isFlexEqual}
                          benefit={getDoubleDeepPPO(
                            plan as IFullPlanDetailPPO,
                            "SSBCI",
                            "Flex Allowance"
                          )}
                        />
                      )
                    ) : null}
                    {part.name === "Transportation" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isTransEqual}
                          benefit={getDoubleDeepHMO(
                            plan as IFullPlanDetail,
                            "Transportation",
                            "Transportation Services"
                          )}
                        />
                      ) : (
                        <PPODoubleDeepInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isTransEqual}
                          benefit={getDoubleDeepPPO(
                            plan as IFullPlanDetailPPO,
                            "Transportation",
                            "Transportation Services"
                          )}
                        />
                      )
                    ) : null}
                    {part.name === "Caregiver Support" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isCaregiverEqual}
                          benefit={getSingleDeepHMO(
                            plan as IFullPlanDetail,
                            "Support for Care Givers Of Enrollee"
                          )}
                        />
                      ) : (
                        <PPODoubleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isCaregiverEqual}
                          benefit={getDoubleDataPPO(
                            plan as IFullPlanDetailPPO,
                            selectedYear === 2024
                              ? "Support for Caregivers of Enrollees"
                              : "Support for Care Givers of Enrollee"
                          )}
                        />
                      )
                    ) : null}
                    {part.name === "Grocery SSBCI Eligible" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isSSBCIEqual}
                          benefit={getDoubleDeepHMO(
                            plan as IFullPlanDetail,
                            "SSBCI",
                            selectedYear === 2024
                              ? "Groceries Benefit (SSBCI)"
                              : "Special Supplemental Benefits for the Chronically Ill (SSBCI) Groceries Benefit"
                          )}
                        />
                      ) : (
                        <PPODoubleDeepInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isSSBCIEqual}
                          benefit={getDoubleDeepPPO(
                            plan as IFullPlanDetailPPO,
                            "SSBCI",
                            selectedYear === 2024
                              ? "Groceries Benefit (SSBCI)"
                              : "Special Supplemental Benefits for the Chronically Ill (SSBCI) Groceries Benefit"
                          )}
                        />
                      )
                    ) : null}
                  </div>
                ))}
              </div>
            ))
          : null
      )}
    </div>
  );
};

export default ComparisonTableAdditionalBenefits;
